import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class MatIconRegistryService {
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly platformId = inject(PLATFORM_ID);


  registerIcons(): void {
    const iconNames = [
      'key',
      'user',
      'basket-selected',
      'add-circle',
      'minus-circle',
      'user-selected',
      'basket',
      'list',
      'arrow-back',
      'arrow-back-orange',
      'pencil-icon',
      'end-use',
      'modify-icon',
      'access-time',
      'basket-payments',
      'show-password',
      'x-twitter',
      'instagram',
      'linkedin',
      'icons',
      'aerosol',
      'gel',
      'deodorant_stick_clear',
      'jar',
      'antiperspirant_roll_on',
      'solid',
      'antiperspirant_stick',
      'coloration',
      'coloration_peroxide',
      'bottle_shine',
      'oil',
      'wavy_hair',
      'bottle',
      'dry',
      'foam',
      'jar_powder',
      'spray',
      'bath_foam',
      'bath_oil',
      'bath_salts',
      'bath_bomb',
      'hand_sanitizer',
      'solid_wash',
      'pump_bottle',
      'shave_foam',
      'shave_gel',
      'wipes',
      'foundation',
      'depilatory',
      'eye_care',
      'moisturizer_cream',
      'serum',
      'lipcare',
      'lipstick',
      'spray_selftan',
      'sunscreen',
      'tablets',
      'canister',
      'liquid_capsule',
      'powder',
      'stain_remover',
      'surface_spray',
      'liquid_bottle',
      'perfume',
      'candle',
      'cat_litter',
      'plug-in',
      'electric_membrane',
      'rose',
      'pottery',
      'diffusor',
      'liquid',
      'hand_dishwash_bar',
      'hand_dishwash_liquid',
      'dishwash_machine_smell',
      'dishwash_machine_tab',
      'dishwash_machine_gel',
      'dishwash_machine_liquid',
      'cleaning',
      'car',
      'oven',
      'shoe_polish',
      'surface_spray_ph_high',
      'surface_spray_ph_low',
      'window',
      'wc_adhesive_block',
      'wc_block_liquid',
      'wc_block_liquid_ph_low',
      'wc_block_liquid_javel',
      'wc_block_liquid_h2o2',
      'wc_powder',
      'wc_rim_block',
      'bottle_cream',
      'balm',
      'surface',
      'wc_block',
      'pets',
      'palm',
      'generosity',
      'excited',
      'candle',
      'confident',
      'relaxing',
      'empathy',
      'electricity',
      'brain',
      'fulfillment',
      'happy',
      'invigorating',
      'senses',
      'mischievousness',
      'sparkling',
      'player',
      'trophy',
      'relax',
      'mouth',
      'tuxedo_smoking',
      'wind',
      'baroque_chic',
      'shell',
      'house',
      'eastern',
      'ethnic',
      'cactus',
      'forest',
      'industry',
      'sea',
      'mountain',
      'candle',
      'tea',
      'rain',
      'scandinavian',
      'sun',
      'rose',
      'relaxing',
      'palm',
      'urban',
      'snowflakes',
      'mail',
      'palm',
      'generosity',
      'excited',
      'confident',
      'relaxing',
      'empathy',
      'electricity',
      'brain',
      'fulfillment',
      'happy',
      'invigorating',
      'senses',
      'mischievousness',
      'sparkling',
      'player',
      'trophy',
      'relax',
      'mouth',
      'tuxedo_smoking',
      'wind',
      'baroque_chic',
      'shell',
      'house',
      'eastern',
      'ethnic',
      'cactus',
      'industry',
      'sea',
      'mountain',
      'tea',
      'rain',
      'scandinavian',
      'sun',
      'urban',
      'snowflakes',
      'trash',
      'need_capture',
      'fragrance_selection',
      'bottles',
      'bottles_dark',
      'delivery',
      'purple-check-icon',
      'payment-failed-icon',
      'aromatic',
      'citrus',
      'fruit',
      'cake',
      'musky',
      'forest',
      'man-flag-icon',
      'website-icon',
      'perfume-icon',
      'watch',
      'whatsapp',
      'mobile-menu-logo',
      'mobileMenuClose',
      'account',
      'language',
      'long_lasting',
      'Natural',
      'chypre',
      'fougere',
      'close',
      'magic',
      'wellbeing',
      'calcul',
      'recap',
      'triple-dots',
      'local-shipping',
      'halal',
      'ifra',
      'halal-catalog',
      'ifra-catalog',
      'cradit_cards',
      'contract',
      'rate',
      'bank',
      'warning',
      'arrow-forward',
      'send-mail',
    ];
    if (isPlatformBrowser(this.platformId)) {
      const iconList = iconNames.map(name => ({
        name: name,
        url: `/assets/icons/${name}.svg`,
      }));

      iconList.forEach(icon => {
        try {
          const safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(icon.url);
          this.matIconRegistry.addSvgIcon(icon.name, safeUrl);
        } catch (error) {
          console.error(`Error registering icon: ${icon.name} from ${icon.url}`, error);
        }
      });
    }
  }
}
